module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1gH7C"))).then(() => parcelRequire('d0iPb'));